/** Deutsches Zahlenformat fuer Mengen und Zaehler. IDs bleiben roh. */
export const zahl = (n: number) => new Intl.NumberFormat('de-DE').format(n);

/** „Größe: L, Farbe: Rot" — leere Namen oder Werte entfallen. */
export function attributText(attribute: Array<{ name: string; wert: string }>): string {
  return attribute
    .filter((a) => a.name.trim() !== '' || a.wert.trim() !== '')
    .map((a) => `${a.name.trim()}: ${a.wert.trim()}`)
    .join(', ');
}
